const incomes = [
  { value: 1, name: '~200万' },
  { value: 2, name: '200万~300万' },
  { value: 3, name: '300万~400万' },
  { value: 4, name: '400万~500万' },
  { value: 5, name: '500万~600万' },
  { value: 6, name: '600万~800万' },
  { value: 7, name: '800万~1000万' },
  { value: 8, name: '1000万~1200万' },
  { value: 9, name: '1200万~1500万' },
  { value: 10, name: '1500万~2000万' },
  { value: 11, name: '2000万~' },
];

const budgets = [
  { value: 500, name: '500万円' },
  { value: 1000, name: '1000万円' },
  { value: 1500, name: '1500万円' },
  { value: 2000, name: '2000万円' },
  { value: 2500, name: '2500万円' },
  { value: 3000, name: '3000万円' },
  { value: 3500, name: '3500万円' },
  { value: 4000, name: '4000万円' },
  { value: 4500, name: '4500万円' },
  { value: 5000, name: '5000万円' },
  { value: 5500, name: '5500万円' },
  { value: 6000, name: '6000万円' },
  { value: 6500, name: '6500万円' },
  { value: 7000, name: '7000万円' },
  { value: 7500, name: '7500万円' },
  { value: 8000, name: '8000万円' },
  { value: 8500, name: '8500万円' },
  { value: 9000, name: '9000万円' },
  { value: 9500, name: '9500万円' },
  { value: 10000, name: '1億円' },
];

export { incomes, budgets };
